module.exports = __webpack_public_path__ + "01f43047/img/lock-icon.bb9c7166.svg";